import React, { FC, useEffect, useRef, useState } from "react";
import { useParams, useLocation, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { initReactI18next, useTranslation } from "react-i18next";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { toMomentString } from "config/util";

import AddAddress from "./AddAddress";
import SendAddress from "./SendAddress";
import QRCode from "qrcode.react";
import LoadingView from "../../components/Loading/LoadingView";
import LoadingButton from "../../components/LoadingButton/index";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { toNumber } from "config/util";
// import Withdraws from "../Withdraws/Withdraws";
// import Deposits from "../WithdrawsDeposits/Withdraws";
import CustomNumber from "components/CustomNumber/CustomNumber.js";
import CustomSelect from "components/CustomSelect/CustomSelect.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import socketIOClient from "socket.io-client";
import env from "../../stores/env";

let socket = null;

const Pay = ({
  loading,
  dispatch_info,
  dispatch_danger,
  dispatch_get_wallets,
  dispatch_post_wallets,
  dispatch_delete_wallets_id,
  dispatch_post_wallets_id_withdraw,
  dispatch_put_wallets_id_deposit,
  dispatch_post_wallets_id_staking,
  dispatch_put_wallets,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const ref = useRef();
  const [t, i18n] = useTranslation();
  const theme = useTheme();
  const primary = theme.palette.primary.main;

  const maps = useSelector((state) => state.reduce_get_maps);
  const [active_symbol, set_active_symbol] = useState(
    Object.keys(maps.coins)[0]
  );

  const [active_tab, set_active_tab] = useState("入金");
  const [active_wallet_id, set_active_wallet_id] = useState("");

  const [modalSendAddress, set_modalSendAddress] = useState(false);
  const [modalAddAddress, set_modalAddAddress] = useState(false);

  useEffect(() => {
    socket = socketIOClient(env.REACT_APP_SOCKET_URL, {
      reconnection: true,
      rejectUnauthorized: false,
      // path: '/socket/markets'
    });

    socket.on("connect", () => {
      // alert("connect")
    });

    socket.on("wallets", () => {
      dispatch_get_wallets({}, (data) => {});
    });

    return () => {
      socket.disconnect();
    };
  }, []);

  const reduce_get_wallets = useSelector((state) => state.reduce_get_wallets);
  const reduce_get_accounts = useSelector((state) => state.reduce_get_accounts);
  const reduce_put_wallets_id_deposit = useSelector(
    (state) => state.reduce_put_wallets_id_deposit
  );

  // if (maps.isLoading || reduce_get_wallets.isLoading) {
  //   return <LoadingView />;
  // }

  const wallets = reduce_get_wallets.wallets;
  const active_wallets_deposit_address = wallets[active_symbol]
    ? wallets[active_symbol].deposit.address
    : "";

  const active_wallets_deposit_balance = wallets[active_symbol]
    ? wallets[active_symbol].deposit.balance
    : "";

  const active_wallets_deposit_wallet_id = wallets[active_symbol]
    ? wallets[active_symbol].deposit.wallet_id
    : "";

  const active_wallets_fiat_flg = wallets[active_symbol]
    ? wallets[active_symbol].fiat_flg
    : "";

  const active_wallets_withdraw = wallets[active_symbol]
    ? wallets[active_symbol].withdraw
    : [];

  function isEmpty(obj) {
    return !Object.keys(obj).length;
  }
  const Deposits = () => {
    let minimumMessage = "";

    if (active_symbol == "BTC") {
      minimumMessage = `(${t("最低")} 0.0002 BTC)`;
    }

    if (active_symbol == "ETH") {
      minimumMessage = `(${t("最低")} 0.0025 ETH)`;
    }

    return (
      <>
        <p>
          {t("お客様の")} <b>{active_symbol}</b> {t("入金用アドレスです。")}
          <br />
          {t(
            "アドレスをコピーするか、2次元バーコードをスキャンしてご利用ください。"
          )}
        </p>
        <div className="jumbotron p-3">
          <small className="text-muted">
            <b>{t("QRコード：")} </b>
          </small>
          <div className="text-center mb-5">
            {active_wallets_deposit_address ? (
              <QRCode
                value={active_wallets_deposit_address}
                size={185}
                includeMargin={true}
              />
            ) : (
              <>
                <LoadingButton
                  onClick={() => {
                    dispatch_put_wallets({ symbol: active_symbol }, () => {
                      dispatch_info(t("反映までしばらくお待ちください・・・"));
                    });
                  }}
                  pending={false}
                  // variant="outlined"
                  variant="contained"
                  style={{
                    backgroundColor: primary,
                    color: "white",
                  }}
                >
                  {t("ウォレットアドレスを作成")}
                </LoadingButton>
              </>
            )}
          </div>
          <div className="text-center mb-5">
            {active_wallets_deposit_address ? (
              <LoadingButton
                onClick={() => {
                  dispatch_put_wallets_id_deposit(
                    { id: active_wallets_deposit_wallet_id },
                    (data) => {
                      dispatch_info(
                        // `${t("残高")}:${data.balance} ${t("を確認致しました。")}`
                        `${t("入金処理を開始しました。")}`
                      );
                    }
                  );
                }}
                pending={reduce_put_wallets_id_deposit.isLoading}
                // variant="outlined"
                variant="contained"
                style={{
                  backgroundColor: primary,
                  color: "white",
                }}
              >
                {`${t("システムに入金反映")} ${minimumMessage}`}
              </LoadingButton>
            ) : (
              <></>
            )}
          </div>

          <div className="form-group bmd-form-group is-filled">
            <label className="bmd-label-floating text-muted">
              <b>{t("ウォレットアドレス：")} </b>
            </label>
            {/* <input
                                type="text"
                                className="form-control"
                                // defaultValue={active_wallets_deposit_address}
                                value={active_wallets_deposit_address}
                                readOnly
                              /> */}
            {active_wallets_deposit_address}
            <div className="text-center">
              <CopyToClipboard
                text={active_wallets_deposit_address}
                onCopy={() => {
                  dispatch_info(t("ウォレットアドレスをコピーしました。"));
                }}
              >
                <button id="code" className="btn btn-link btn-sm">
                  <i className="material-icons">content_copy</i> Copy code
                </button>
              </CopyToClipboard>
            </div>
          </div>
        </div>
      </>
    );
  };

  const Withdraws = () => {
    return (
      <>
        <p>
          <b>{active_symbol}</b> {t("アドレスを選択してください。")}
        </p>
        <dl className="row">
          <dt className="col-sm-3 d-none d-sm-block">
            <small className="text-muted">
              <b>{t("ラベル")}</b>
            </small>
          </dt>
          <dd className="col-sm-9 d-none d-sm-block">
            <small className="text-muted">
              <b>{t("アドレス")}</b>
            </small>
          </dd>
          {active_wallets_withdraw.map((x) => {
            return (
              <>
                <dt className="col-sm-3 border-top pt-3 pt-sm-2">
                  <div className="d-flex justify-content-between">
                    <a
                      href="javascript:void(0);"
                      // data-toggle="modal"
                      // data-target="#sendAddress"
                      onClick={(e) => {
                        e.preventDefault();
                        set_modalSendAddress(true);
                        set_active_wallet_id(x.wallet_id);
                      }}
                    >
                      {x.label}
                    </a>

                    <a
                      href="javascript:void(0);"
                      className="d-sm-none"
                      onClick={(e) => {
                        e.preventDefault();
                        dispatch_delete_wallets_id(
                          {
                            id: x.wallet_id,
                          },
                          () => {
                            dispatch_info("ウォレットアドレスを削除しました。");
                          }
                        );
                      }}
                    >
                      <i className="fas fa-trash-alt" />
                    </a>
                  </div>
                </dt>
                <dd className="col-sm-8 border-sm-top pt-sm-2">
                  <span>{x.address}</span>
                </dd>
                <dt className="col-sm-1 border-sm-top pt-sm-2 text-right d-none d-sm-block">
                  <a
                    href="javascript:void(0);"
                    // data-toggle="modal"
                    // data-target="#addAddress"
                    onClick={(e) => {
                      e.preventDefault();
                      dispatch_delete_wallets_id(
                        {
                          id: x.wallet_id,
                        },
                        () => {
                          dispatch_info("ウォレットアドレスを削除しました。");
                        }
                      );
                    }}
                  >
                    <i className="fas fa-trash-alt" />
                  </a>
                </dt>
              </>
            );
          })}
        </dl>
        <div className="text-center">
          <button
            type="button"
            className="btn btn-outline-primary"
            onClick={() => {
              set_modalAddAddress(true);
            }}
          >
            {t("アドレスを登録する")}
          </button>
        </div>
      </>
    );
  };

  const Deposit = () => {
    return (
      <>
        <p>
          {t("お客様の")} <b>{active_symbol}</b> {t("入金用アドレスです。")}
          <br />
          {t(
            "アドレスをコピーするか、2次元バーコードをスキャンしてご利用ください。"
          )}
        </p>
        <div className="jumbotron p-3">
          <small className="text-muted">
            <b>{t("QRコード：")} </b>
          </small>
          <div className="text-center mb-5">
            {active_wallets_deposit_wallet_id ? (
              <QRCode
                value={active_wallets_deposit_address}
                size={185}
                includeMargin={true}
              />
            ) : (
              <>
                <LoadingButton
                  onClick={() => {
                    dispatch_info(t("反映までしばらくお待ちください・・・"));

                    dispatch_put_wallets({ symbol: active_symbol }, () => {});
                  }}
                  pending={false}
                  // variant="outlined"
                  variant="contained"
                  style={{
                    backgroundColor: primary,
                    color: "white",
                  }}
                >
                  {t("ウォレットアドレスを作成")}
                </LoadingButton>
              </>
            )}
          </div>
          <div className="text-center mb-5">
            {active_wallets_deposit_address ? (
              <LoadingButton
                onClick={() => {
                  dispatch_put_wallets_id_deposit(
                    { id: active_wallets_deposit_wallet_id },
                    (data) => {
                      dispatch_info(
                        // `${t("残高")}:${data.balance} ${t("を確認致しました。")}`
                        `${t("入金処理を開始しました。")}`
                      );
                    }
                  );
                }}
                pending={reduce_put_wallets_id_deposit.isLoading}
                // variant="outlined"
                variant="contained"
                style={{
                  backgroundColor: primary,
                  color: "white",
                }}
              >
                {t("システムに入金反映")}
              </LoadingButton>
            ) : (
              <></>
            )}
          </div>

          <div className="form-group bmd-form-group is-filled">
            <label className="bmd-label-floating text-muted">
              <b>{t("ウォレットアドレス：")} </b>
            </label>
            {/* <input
                                  type="text"
                                  className="form-control"
                                  // defaultValue={active_wallets_deposit_address}
                                  value={active_wallets_deposit_address}
                                  readOnly
                                /> */}
            {active_wallets_deposit_address}
            <div className="text-center">
              <CopyToClipboard
                text={active_wallets_deposit_address}
                onCopy={() => {
                  dispatch_info(t("ウォレットアドレスをコピーしました。"));
                }}
              >
                <button id="code" className="btn btn-link btn-sm">
                  <i className="material-icons">content_copy</i> Copy code
                </button>
              </CopyToClipboard>
            </div>
          </div>
        </div>
      </>
    );
  };

  const Staking = () => {
    const [amount, set_amount] = useState("");
    const [plan_id, set_plan_id] = useState("");

    let maps_staking_plans = {};
    for (var item in maps.staking_plans) {
      const name = maps.staking_plans[item].name;
      const period = maps.staking_plans[item].period;
      const rate = maps.staking_plans[item].rate;

      maps_staking_plans[item] = `${name} ${period}${t("日")} ${rate}%`;
    }

    return (
      <>
        <p>
          {t("お客様の")} <b>{active_symbol}</b> {t("をステーキングします")}
          <br />
          {t("プランを選択して金額を入力してください")}
        </p>
        <div className="jumbotron p-3">
          <div className="text-center mb-5">
            <>
              <GridContainer>
                <GridItem lg={3}></GridItem>
                <GridItem lg={6}>
                  <CustomSelect
                    labelText={t("プラン")}
                    color="primary"
                    set_value={(val) => {
                      set_plan_id(val);
                    }}
                    value={plan_id}
                    maps={maps_staking_plans}
                  />
                  <CustomNumber
                    value={amount}
                    set_value={set_amount}
                    labelText={t("金額")}
                    endAdornment={active_symbol}
                    decimalScale={maps.coin_decimals[active_symbol].price}
                  />
                  <LoadingButton
                    onClick={() => {
                      dispatch_post_wallets_id_staking(
                        {
                          id: active_wallets_deposit_wallet_id,
                          amount,
                          plan_id,
                        },
                        (data) => {
                          dispatch_info(
                            // `${t("残高")}:${data.balance} ${t("を確認致しました。")}`
                            `${t("ステーキングを開始しました。")}`
                          );
                          dispatch_get_wallets({}, (data) => {});
                        }
                      );
                    }}
                    pending={false}
                    // variant="outlined"
                    variant="contained"
                    style={{
                      backgroundColor: primary,
                      color: "white",
                    }}
                  >
                    {t("実行する")}
                  </LoadingButton>
                </GridItem>
                <GridItem lg={3}></GridItem>
              </GridContainer>
            </>
          </div>
        </div>
      </>
    );
  };

  const StakingData = () => {
    const stakinglist = wallets[active_symbol].staking;

    return (
      <>
        <p>{t("ステーキング中")}</p>
        <table style={{ width: "100%" }}>
          <thead>
            <tr>
              <th colspan="1">{t("金額")}</th>
              <th colspan="1">{t("報酬")}</th>
              <th colspan="1">{t("終了日")}</th>
              <th colspan="1">{t("プラン名")}</th>
            </tr>
          </thead>
          <tbody>
            {stakinglist.map((staking) => {
              const amount = staking.amount;
              const reward = staking.reward;
              const expirationed_at_label = toMomentString(
                staking.expirationed_at,
                // "YYYY/MM/DD HH:mm"
                "YYYY/MM/DD"
              );
              const name = staking.name;

              return (
                <>
                  <tr>
                    <td>{amount}</td>
                    <td>{reward}</td>
                    <td>{expirationed_at_label}</td>
                    <td>{name}</td>
                  </tr>
                </>
              );
            })}
          </tbody>
        </table>
      </>
    );
  };
  
  const maps_coins = maps.coins;
  // delete maps_coins["CHC"];


  return (
    <div className="wrapper">
      <SendAddress
        loading={loading}
        modal={modalSendAddress}
        close_modal={() => {
          set_modalSendAddress(false);
        }}
        dispatch_info={dispatch_info}
        dispatch_danger={dispatch_danger}
        active_wallet_id={active_wallet_id}
        active_symbol={active_symbol}
        dispatch_post_wallets_id_withdraw={dispatch_post_wallets_id_withdraw}
        active_wallets_deposit_balance={active_wallets_deposit_balance}
      />
      <AddAddress
        loading={loading}
        modal={modalAddAddress}
        close_modal={() => {
          set_modalAddAddress(false);
        }}
        active_symbol={active_symbol}
        dispatch_post_wallets={dispatch_post_wallets}
      />
      <div className="main-panel">
        <nav className="navbar navbar-expand-lg navbar-transparent navbar-absolute fixed-top ">
          <div className="container-fluid">
            <div className="navbar-wrapper">
              <a className="navbar-brand" href="javascript:void(0);">
                <i className="material-icons">payment</i>
                {t("入出金")}
              </a>
            </div>
            <button
              className="navbar-toggler"
              type="button"
              data-toggle="collapse"
              aria-controls="navigation-index"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="sr-only">Toggle navigation</span>
              <span className="navbar-toggler-icon icon-bar" />
              <span className="navbar-toggler-icon icon-bar" />
              <span className="navbar-toggler-icon icon-bar" />
            </button>
            <div className="collapse navbar-collapse justify-content-end">
              <ul className="navbar-nav">
                <li className="nav-item">
                  <a
                    href="settings.html"
                    className="nav-link"
                    onClick={(e) => {
                      e.preventDefault();
                      history.push({
                        pathname: `/settings`,
                      });
                      window.scroll(0, 0);
                    }}
                    style={{ textTransform: "none" }}
                  >
                    <i className="material-icons">account_circle</i>
                    {reduce_get_accounts.mail_address}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </nav>
        <div className="content">
          <div className="container-fluid">
            <div className="card">
              <div className="card-header card-header-dark d-none d-md-block">
                <h4 className="card-title">{t("入出金")}</h4>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-sm-3">
                    <select
                      className="custom-select d-sm-none"
                      onChange={(e) => {
                        set_active_symbol(e.target.value);
                      }}
                    >
                      {Object.keys(maps_coins).map((k, idx) => {
                        return (
                          <option value={k} key={idx}>
                            {k}
                            {"　"}
                            {wallets[k] && !isEmpty(wallets[k].deposit)
                              ? toNumber(
                                  wallets[k].deposit.balance,
                                  maps.coin_decimals[k].price
                                )
                              : ""}
                            {/* <div className="d-flex justify-content-between">
                                <div>{k}</div>
                                <div>{wallets[k].deposit.balance}</div>
                              </div> */}
                          </option>
                        );
                      })}
                    </select>
                    <div className="list-group d-none d-sm-block">
                      {Object.keys(maps_coins).map((k, idx) => {
                        return (
                          <a
                            href="#"
                            className={`list-group-item list-group-item-action  ${
                              active_symbol === k ? "active" : ""
                            }`}
                            onClick={() => {
                              set_active_symbol(k);
                            }}
                            key={idx}
                          >
                            <div className="d-flex justify-content-between">
                              <div>{k}</div>{" "}
                              <div>
                                {/* <span className="text-info"> */}
                                {/* {wallets[k].deposit.balance} */}
                                {wallets[k] && !isEmpty(wallets[k].deposit)
                                  ? toNumber(
                                      wallets[k].deposit.balance,
                                      maps.coin_decimals[k].price
                                    )
                                  : ""}
                                {/* </span> */}
                              </div>
                            </div>
                          </a>
                        );
                      })}
                    </div>
                  </div>
                  <div className="col-sm">
                    <div className="card">
                      <div className="card-header card-header-tabs card-header-primary">
                        <div className="nav-tabs-navigation">
                          <div className="nav-tabs-wrapper">
                            <ul
                              className="nav nav-tabs nav-justified"
                              data-tabs="tabs"
                            >
                              <li className="nav-item">
                                <a
                                  href="#input"
                                  className={`nav-link ${
                                    active_tab === "入金" ? "active" : ""
                                  }`}
                                  id="input-tab"
                                  data-toggle="tab"
                                  role="tab"
                                  aria-controls="input"
                                  aria-selected="true"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    set_active_tab("入金");
                                  }}
                                >
                                  <i className="material-icons d-none d-sm-inline-block">
                                    cloud_download
                                  </i>{" "}
                                  {t("入金")}
                                </a>
                              </li>
                              <li className="nav-item">
                                <a
                                  href="#output"
                                  className={`nav-link ${
                                    active_tab === "出金" ? "active" : ""
                                  }`}
                                  id="output-tab"
                                  data-toggle="tab"
                                  role="tab"
                                  aria-controls="output"
                                  aria-selected="false"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    set_active_tab("出金");
                                  }}
                                >
                                  <i className="material-icons d-none d-sm-inline-block">
                                    cloud_upload
                                  </i>{" "}
                                  {t("出金")}
                                </a>
                              </li>
                              <li className="nav-item">
                                <a
                                  href="#staking"
                                  className={`nav-link ${
                                    active_tab === "ステーキング"
                                      ? "active"
                                      : ""
                                  }`}
                                  id="staking-tab"
                                  data-toggle="tab"
                                  role="tab"
                                  aria-controls="staking"
                                  aria-selected="false"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    set_active_tab("ステーキング");
                                  }}
                                >
                                  <i className="material-icons d-none d-sm-inline-block">
                                    cloud_upload
                                  </i>{" "}
                                  {t("ステーキング")}
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="card-body tab-content">
                        <div
                          className={`tab-pane fade show  ${
                            active_tab === "入金" ? "active" : ""
                          }`}
                          id="input"
                          role="tabpanel"
                          aria-labelledby="input-tab"
                        >
                          <Deposits symbol={active_symbol} />
                        </div>
                        <div
                          className={`tab-pane fade show  ${
                            active_tab === "出金" ? "active" : ""
                          }`}
                          id="output"
                          role="tabpanel"
                          aria-labelledby="output-tab"
                        >
                          <Withdraws symbol={active_symbol} />
                        </div>
                        <div
                          className={`tab-pane fade show  ${
                            active_tab === "ステーキング" ? "active" : ""
                          }`}
                          id="staking"
                          role="tabpanel"
                          aria-labelledby="staking-tab"
                        >
                          {/* {!isEmpty(wallets[active_symbol].deposit) &&
                          active_symbol === "SCC" ? (
                            <>
                              {wallets[active_symbol] &&
                              wallets[active_symbol].staking &&
                              !isEmpty(wallets[active_symbol].staking) ? (
                                <>
                                  <StakingData symbol={active_symbol} />
                                </>
                              ) : (
                                <Staking symbol={active_symbol} />
                              )}
                            </>
                          ) : (
                            <>{t("ステーキングはSCCのみ対応しております。")}</>
                          )} */}

                          {active_symbol === "SCC" ? (
                            <>
                              <Staking symbol={active_symbol} />
                              <StakingData symbol={active_symbol} />
                            </>
                          ) : (
                            <>{t("ステーキングはSCCのみ対応しております。")}</>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>{" "}
              {}
            </div>{" "}
            {}
          </div>{" "}
          {}
        </div>
        <footer className="footer">
          <div className="container-fluid d-flex flex-column flex-md-row justify-content-center justify-content-md-between">
            <div className="pl-3 ml-md-0">
              <small>Version 1.0.0</small>
            </div>
            <small>© ZeptoHash</small>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default Pay;
